import React from 'react';

import classNames from 'classnames';
import classes from './VerificationCodeSymbol.module.scss';

type VerificationCodeSymbolProps = {
  value: string;
  isActive?: boolean;
  error?: boolean;
  onClick?: () => void;
};

const VerificationCodeSymbol = ({
  value,
  isActive,
  error,
  onClick,
}: VerificationCodeSymbolProps) => {
  const symbolClasses = classNames(classes.symbol, {
    [classes.error]: error,
    [classes.active]: isActive,
  });

  return (
    <span onClick={onClick} className={symbolClasses}>
      {value}
    </span>
  );
};

export { VerificationCodeSymbol };
